<template>
  <div class="bs-page">
    <div class="bs-grid-overlay" aria-hidden="true"></div>
    <div class="bs-glow bs-glow-one" aria-hidden="true"></div>

    <StandardNavBar />

    <main>
      <PageHero
        eyebrow="Our work"
        title="Photographs from"
        subtitle="live sites, not stock."
        lead="Every photo below was taken on a Blue Speed job. They cover both divisions — façade cleaning, painting, sealant and cladding works carried out on rope, alongside repair, waterproofing and reinstatement works on the ground."
        :image="heroImage.src"
        :image-alt="heroImage.alt"
        :image-caption="heroImage.caption"
      />

      <!-- ============ GALLERY ============ -->
      <section id="gallery" class="section-pad gallery-section shell">
        <div class="section-head">
          <div>
            <p class="eyebrow">
              <span class="eyebrow-line"></span>
              Project photography
            </p>
            <h2 class="display-2">
              {{ workPhotos.length }} photographs,
              <span>across both divisions.</span>
            </h2>
          </div>

          <p class="lead">
            Filter by division, or select any photo to see it full size. Where the building is named,
            it is named with the client's agreement.
          </p>
        </div>

        <div class="gallery-wrap">
          <WorkGallery />
        </div>
      </section>

      <SectionCta
        eyebrow="Similar scope?"
        heading="If your building needs any of this, tell us about it."
        body="Send the works required, the building type and the site location. We will advise on the approach, the access method and the next practical step."
      />
    </main>

    <SiteFooter />
  </div>
</template>

<script>
import PageHero from "@/components/PageHero.vue";
import SectionCta from "@/components/SectionCta.vue";
import SiteFooter from "@/components/SiteFooter.vue";
import StandardNavBar from "@/components/StandardNavBar.vue";
import WorkGallery from "@/components/WorkGallery.vue";
import { pageHeroes, workPhotos } from "@/content/gallery";

export default {
  name: "WorkPage",

  components: {
    PageHero,
    SectionCta,
    SiteFooter,
    StandardNavBar,
    WorkGallery,
  },

  data() {
    return {
      workPhotos,
      heroImage: pageHeroes.work,
    };
  },
};
</script>

<style scoped>
.gallery-wrap {
  margin-top: 52px;
}
</style>
